/**
 * Listbox scroll handler for MUI Autocomplete with `hasMore` / `loadMore`
 * pagination. Wire as `slotProps={{ listbox: { onScroll: (e) => handleAutocompleteOnScroll(e, hasMore, loadMore, loading) } }}`.
 *
 * For Pattern A filter selectors that keep pagination/accumulation state
 * inside the component (legacy shape), use `createListboxScrollHandler` instead.
 */
export const handleAutocompleteOnScroll = (
  event: React.UIEvent<HTMLElement>,
  hasMore?: () => boolean,
  loadMore?: () => void,
  loading?: boolean
): void => {
  const listbox = event.currentTarget;
  if (
    listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 5 &&
    hasMore &&
    hasMore() &&
    loadMore &&
    !loading
  ) {
    loadMore();
  }
};
